// Cloudinary browser upload helper (unsigned upload preset).
// Configure with REACT_APP_CLOUDINARY_CLOUD_NAME and REACT_APP_CLOUDINARY_UPLOAD_PRESET.

export const CLOUDINARY_CLOUD_NAME =
  process.env.REACT_APP_CLOUDINARY_CLOUD_NAME || "";
export const CLOUDINARY_UPLOAD_PRESET =
  process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET || "";

export function isCloudinaryConfigured() {
  return Boolean(CLOUDINARY_CLOUD_NAME && CLOUDINARY_UPLOAD_PRESET);
}

/**
 * Upload a file (image or video) directly from the browser to Cloudinary
 * using an unsigned preset. Returns { url, resource_type, format, bytes, ... }.
 * onProgress is called with a 0..1 float.
 */
export function uploadToCloudinary(file, onProgress) {
  return new Promise((resolve, reject) => {
    if (!isCloudinaryConfigured()) {
      reject(new Error("Cloudinary is not configured. Set REACT_APP_CLOUDINARY_CLOUD_NAME and REACT_APP_CLOUDINARY_UPLOAD_PRESET."));
      return;
    }
    const url = `https://api.cloudinary.com/v1_1/${CLOUDINARY_CLOUD_NAME}/auto/upload`;
    const form = new FormData();
    form.append("file", file);
    form.append("upload_preset", CLOUDINARY_UPLOAD_PRESET);
    form.append("folder", "scl-kindness-expo");

    const xhr = new XMLHttpRequest();
    xhr.open("POST", url);
    xhr.upload.onprogress = (e) => {
      if (e.lengthComputable && onProgress) onProgress(e.loaded / e.total);
    };
    xhr.onload = () => {
      try {
        const data = JSON.parse(xhr.responseText);
        if (xhr.status >= 200 && xhr.status < 300) {
          resolve({
            url: data.secure_url,
            resource_type: data.resource_type, // "image" or "video"
            format: data.format,
            bytes: data.bytes,
            width: data.width,
            height: data.height,
            duration: data.duration,
            public_id: data.public_id,
          });
        } else {
          reject(new Error(data?.error?.message || `Upload failed (${xhr.status})`));
        }
      } catch (err) {
        reject(err);
      }
    };
    xhr.onerror = () => reject(new Error("Network error uploading to Cloudinary"));
    xhr.send(form);
  });
}

/** Build a Cloudinary thumbnail URL from a full Cloudinary secure_url */
export function cloudinaryThumb(url, { w = 200, h = 200 } = {}) {
  if (!url || !url.includes("/upload/")) return url;
  // For videos, use so_0 to grab a poster frame automatically
  const isVideo = /\/video\/upload\//.test(url);
  const transform = isVideo
    ? `c_fill,g_auto,w_${w},h_${h},so_0,f_jpg,q_auto`
    : `c_fill,g_auto,w_${w},h_${h},f_auto,q_auto`;
  return url.replace("/upload/", `/upload/${transform}/`);
}
